<template>
  <div class="toggle">
    <label class="toggle__label">{{ this.label }}</label>
    <VSwitchButton :checked="this.checked" @click="onClick" />
  </div>
</template>

<script>
export default {
  name: "VToggle",
  components: {
    VSwitchButton: () => import("../VSwitchButton")
  },
  props: {
    label: {
      type: String,
      default: "Mostrar em destaque",
      required: true
    },
    checked: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      highlight: false
    };
  },
  methods: {
    onClick(e) {
      this.highlight = e;
      this.$emit("input", this.highlight);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/typography";

.toggle {
  display: flex;

  &__label {
    font-size: size(16);
    margin-right: 16px;
    font-weight: 500;
    transition: all 2s ease-out;
    color: #616161;
  }
}
</style>
